import React, { useCallback } from "react";
import { Select, Divider, List, Avatar } from "antd";
import { upperCase } from "lodash";

import nobulLogo from "assets/nobul-logo.svg";

const { Option } = Select;

const statusMap = [
  {
    message: (name) => (
      <p>
        Verify or reject <strong>{name}'s</strong> video
      </p>
    ),
    label: "select status here",
    value: "pending"
  },
  {
    message: (name) => (
      <p>
        You are verifying <strong>{name}'s</strong> video
      </p>
    ),
    label: "verify",
    value: "verified"
  },
  {
    message: (name) => (
      <p>
        You are rejecting <strong>{name}</strong>'s video
      </p>
    ),
    label: "reject",
    value: "rejected"
  }
];

const PopconfirmVerifyVideo = ({ name, advisor, data, setData }) => {
  const { firstName, lastName, userType } = advisor;
  const { verificationStatus } = data;

  const captureData = useCallback(
    (input) => {
      setData((state) => ({ ...state, verificationStatus: input }));
    },
    [setData]
  );

  const { message, value } =
    statusMap.find(({ value }) => value === verificationStatus) || statusMap[0];

  return (
    <div>
      <List itemLayout="horizontal">
        <List.Item>
          <List.Item.Meta
            avatar={<Avatar src={nobulLogo} />}
            title={`${firstName} ${lastName}`}
            description={`Nobul ${userType} verifying ${name}'s video`}
          />
        </List.Item>
      </List>
      <Divider style={{ margin: "4px 0 12px 0" }} />
      {message(name)}
      <Select
        style={{ display: "block", marginTop: 4 }}
        defaultActiveFirstOption
        defaultValue={value}
        onSelect={captureData}
      >
        {statusMap.map((status, index) => (
          <Option
            key={status.value}
            value={status.value}
            disabled={index === 0}
          >
            {upperCase(status.label)}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default PopconfirmVerifyVideo;
